import React, { Component, Fragment } from "react";
import { connect } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ItemSection from '../../../Section/ItemSection';
import { processResponse, processItemResponse } from '../../../../../utilities/processResponse';
import { getQuestionList } from '../../../../../actions/SurveyAction';
import { Button, Container } from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';
import { isMobile, isTablet, deviceType } from 'react-device-detect';
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { max, times } from "lodash";

class ImageItemResponse extends Component {
    constructor(props) {
        super(props);
        this.state = {
            timerId: null,
            isStartButton: false,
            isContinueButton: false,
            timer: 0,
            isSelect: false,
            isApiCall: false,
            showModal: false,
            isPlaying: true,
            isClick: false,
            isContinue: false,
            isImageLoaded: false,
            imgBorder: 0,
            remainTime: null,
            imageIndex: null,
            popUpModal: false,
            isClickable: true,
            blackScreenStartTime: null,
            totalScrnDelay: null,
            selectedImageIndex: null,
            selectedImageName: null,
            isVisible: false,
            checkValue: false,
            isHiding: false,
            itemResponseTime: 0,
            isAvailable: false,
            isImageSelected: false,
            lastSelected: false,
            clickedValue: 0,
        }
        this.reviewPage = this.props.questionItemList || [];
        this.slideIndex = 0;
        this.timerId = null;
        this.buttonHide = null;
        this.arrList = [];
        this.imageList = [];
        this.tempIndex = [];
        this.firstOne = 0;
        this.itemBlock = 0;
        this.nextCount = 0;
        this.progressVal = 0;
        this.startTime = new Date();
        this.endTime = null;
        this.sequenceCount = 1;
        this.selectedCount = 0;
        this.responseValue = 0;
        this.isCall = true;
        this.isLoadSlider = false;
        this.selectedItemArr = [];
        this.isImages = [];
        this.itemCollection = [];
        this.eventType = false;
        this.itemChangeCount = 0;
        this.clickCount = 0;
        this.started = false;
        this.runningTime = null;
        this.selectionTime = null;
        this.handleLoadClick = false;
        this.reDisplayed = null;
        this.clickedValues = 0;
        this.mainState = false;
        this.itemResponseValue = 0;
        this.setOfTheImages = []
    }

    componentDidMount() {
        const { configuration, items, pageInstrumentConfiguration, itemCount, activePageKey } = this.props;
        const { buttons, sections } = pageInstrumentConfiguration;
        const { scaleResponses } = configuration;
        const { extraTimeToSelect } = configuration.itemTypeProperties;
        this.selectionTime = extraTimeToSelect;
        if(configuration.key === items.scaleKey){
            var socializationImages = Array.isArray(items.socializationImages) ? items.socializationImages.map(function(imageUrl) { return { responseImageUrl: imageUrl }; }) : [];
            scaleResponses.unshift(...socializationImages)
            this.setOfTheImages.push(...socializationImages);
        }
        var slides = document.getElementsByClassName(`_imageItemTypeUrl_${configuration.key}`);
        var itemBlock = document.getElementsByClassName(`_ImageItemType`);
        this.buttonHide = document.getElementById("_ButtonHide_" + configuration.key);
        this.itemBlock = itemCount.length || 0;
        if (this.buttonHide !== null) {
            this.buttonHide.style.display = "inline";
        }
        /** Image slide */
        for (var i = 0; i < slides.length; i++) {
            slides[i].style.display = "none";
        }
        for (let index = 0; index < scaleResponses.length; index++) {
            this.arrList.push(index);
        }
        /** Item block  */
        itemBlock[this.firstOne].style.display = "block";
        for (let index = 0; index < itemBlock.length; index++) {
            if (this.firstOne !== index) {
                // itemBlock[index].style.display = "none";
            }
        }
        this.tempIndex = this.uniqueShuffle(this.arrList, this.props.pageNumber);
        document.addEventListener('keypress', () => {
            this.handleOutClick();
            this.handleCheckmkLateSelection();
        }, true);
        //disabling the next button    
        const { readyToStartButton } = configuration;
        var nextButton = document.getElementsByClassName(`_buttonHideClass_${activePageKey}`)[0];
        if (readyToStartButton) {
            nextButton.style.display = 'none'
        }
        if (window.innerHeight > window.innerWidth) {
            this.setState({ checkOre: 'portrait' });
        } else {
            this.setState({ checkOre: 'landscape' });
        }

        window.addEventListener("resize", (event) => {
            if (window.innerHeight > window.innerWidth) {
                this.setState({ checkOre: "portrait" });
            } else {
                this.setState({ checkOre: "landscape" });
            }
            for (var i = 0; i < slides.length; i++) {
                if (this.state.imageIndex !== i) {
                    slides[i].style.display = "none";
                }
            }
            if (!this.props.openOreModal && this.state.remainTime !== null) {
                this.handleImageLoad()
            }
        });
        document.addEventListener("click", this.handleLastClick);
    }

    setOrientation = (orientation) => {
        this.setState({ checkOre: orientation })
    }

    componentDidUpdate() {
        // debugger;
        const { currentActivePageCount, pageNumber, configuration, items, activePageNumber } = this.props;
        var activePageCount = currentActivePageCount + 1;
        /** Auto start */
        var slides = document.getElementsByClassName(`_imageItemTypeUrl_${configuration.key}`);
        if (this.isLoadSlider === true) {

            for (var i = 0; i < slides.length; i++) {
                slides[i].style.display = "none";
            }
            this.isLoadSlider = false;
        }

        if (items.itemType === "5" && configuration.startButton === null && pageNumber === activePageCount) {
            setTimeout(() => {
                if (this.isCall) {
                    this.isCall = false;
                }
            }, 0);
        }
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        var imageRow = document.getElementsByClassName("imageItemResponseRow");

        if (imageRow[0] !== undefined) {
            imageRow[0].addEventListener("contextmenu", (e) => {
                e.preventDefault();
            }, false);
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize");
    }


    async componentWillReceiveProps(nextProps) {
        const { getAllItemResponse, items, configuration, scaleResponses, itemResponses, getAllItemResponseForMultiple, ratees, rateeKey, putAllForItemCollection, activePageKey } = await nextProps;
        const { itemResponseSets } = getAllItemResponse;
        const { readyToStartButton } = configuration
        var nextButton = document.getElementsByClassName(`_buttonHideClass_${activePageKey}`)[0];
        if (items.isAnswer == false) {
            nextButton.style.display = 'none';
        } else {
            nextButton.style.display = 'inline';
        }
        for (const key in getAllItemResponseForMultiple) {
            this.isUpdateResponse = true;

            if (Object.hasOwnProperty.call(getAllItemResponseForMultiple, key)) {
                const elementRes = getAllItemResponseForMultiple[key];
                const { itemResponseSets } = elementRes;

                if (rateeKey !== undefined && key === rateeKey) {
                    for (const key in itemResponseSets) {
                        if (itemResponseSets.hasOwnProperty(key)) {
                            const element = itemResponseSets[key];
                            const tempItemResponseSets = itemResponseSets[key];
                            const scaleResponseTemp = scaleResponses.scaleResponses;
                            if (element.itemKey.toLowerCase() === items.key.toLowerCase()) {
                                this.reviewPage[items.key][0].userResponse = element.itemResponses;
                                var itemResponsesObj = element.itemResponses.length > 0 ? element.itemResponses : element.demographicResponses.length > 0 ? element.demographicResponses : []

                                itemResponsesObj.forEach(item => {
                                    for (const key in scaleResponseTemp) {
                                        if (scaleResponseTemp.hasOwnProperty(key)) {
                                            const scaleResponses = scaleResponseTemp[key];
                                            if (parseInt(scaleResponses.response) === parseInt(item.response)) {
                                                item.responseDescription = scaleResponses.responseDescription;
                                            }
                                        }
                                    }
                                    if (this.state.isSelect === false) {
                                        this.setState({
                                            isSelect: true,
                                        });
                                    }
                                });

                                for (const key in tempItemResponseSets.itemResponses) {
                                    if (tempItemResponseSets.itemResponses.hasOwnProperty(key)) {
                                        const temp = tempItemResponseSets.itemResponses[key];
                                        const itemList = this.reviewPage[items.reviewPageKey];

                                        for (const key in itemList) {
                                            if (itemList.hasOwnProperty(key)) {
                                                const itemRes = itemList[key];
                                                var itemResponseArr = tempItemResponseSets.itemResponses.length > 0 ? tempItemResponseSets.itemResponses : tempItemResponseSets.demographicResponses.length > 0 ? tempItemResponseSets.demographicResponses : [];
                                                this.sequenceCount = itemResponseArr.length + 1;

                                                if (this.state.isSelect === false) {
                                                    itemRes.isAnswer = true;
                                                    itemRes.isRequired = false;

                                                    itemRes.itemResponses[tempItemResponseSets.itemKey] = itemResponseArr;
                                                    var itemType = configuration.itemType;
                                                    var responseSet = this.props.itemResponses[tempItemResponseSets.itemKey] = {};
                                                    processItemResponse(tempItemResponseSets.itemKey, responseSet, tempItemResponseSets.itemResponses, itemType, rateeKey, putAllForItemCollection, "onLoad");
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            if (element.itemResponses.length < 1) {
                                items.isAnswer = false;

                            }
                        }
                    }
                }
            }
        }

        this.onImgLoad();
    }

    handleCheckmkLateSelection = ()=>{
        const { configuration } = this.props;
        const { extraTimeToSelect } = configuration.itemTypeProperties;
        if(extraTimeToSelect > 0){
            if(this.clickCount === 1){
                this.setState({isVisible:true})
                setTimeout(() => {
                    this.setState({isVisible:false})
                }, 300);
            }
        }
    }

    handleEvents = (id) => {
        try {
            const { configuration } = this.props;
            var slides = document.getElementsByClassName(`_imageItemTypeUrl_${configuration.key}`);

            var index = slides[id].getAttribute('data-index');
            var newItem = slides[id].getAttribute('data-id');
            var itemsData = JSON.parse(newItem);
            this.handleImageItem(itemsData, index + 1);
        } catch (error) {
            console.log(error.message)
        }
    }

    handleImageItemKeyPress = (id) => {
        try {

            document.addEventListener('keypress', () => {
                this.handleEvents(id);
            }, true);

            document.addEventListener('mousedown', (e) => {
                this.handleEvents(id);
            }, true);

            document.addEventListener('touchstart', () => {
                this.handleEvents(id);
            }, true);

        } catch (error) {
            console.log("Exceptions: while adding keypress event in image selection:_", error.message);
        }
    };

    handleImageLoad = () => {
        try {
            const { configuration, isLastPage } = this.props;
            const { randomizePresentation, minSelections, maxTimeToSelect, extraTimeToSelect, imageInterval } = configuration.itemTypeProperties;
            // debugger;

            var totalTime = null;
            // debugger;
            if (extraTimeToSelect > 0 && imageInterval > 0) {
                totalTime = parseInt(imageInterval) + parseInt(extraTimeToSelect);
            } else if (extraTimeToSelect > 0) {
                totalTime = parseInt(extraTimeToSelect);
            } else if (imageInterval > 0) {
                totalTime = parseInt(imageInterval);
            } else {
                totalTime = 0; // Set a default value if none of the variables have values
            }
            var slides = document.getElementsByClassName(`_imageItemTypeUrl_${configuration.key}`);

            var progressBar = document.getElementsByClassName(`_imageProgressBar_${configuration.key}`);

            this.started = true;

            var slideCount = slides.length || 0;
            for (var i = 0; i < slides.length; i++) {
                this.setState({ isImageSelected: false })
                if (slides[i].style !== undefined) {
                    slides[i].style.display = "none";
                }
            }

            var randomIndex = this.tempIndex[this.slideIndex] || 0;
            var imageCount = this.slideIndex;

            this.setState({ imgBorder: 0 });
            if (parseInt(randomizePresentation) === 1) {
                this.itemChangeCount = randomIndex
                slides[randomIndex].style.display = slideCount !== imageCount ? "block" : "none";
                if (slideCount !== imageCount) {
                    this.setState({ imageIndex: randomIndex });
                }
              
                this.clickCount = 0;
                this.startTime = new Date();

                document.removeEventListener('keypress', () => {
                    this.handleOutClick();
                });
            } else {
                this.itemChangeCount = imageCount;
                slides[this.slideIndex].style.display = slideCount !== imageCount ? "block" : "none";
                if (slideCount !== imageCount) {
                    this.setState({ imageIndex: this.slideIndex });
                }
                this.clickCount = 0;
                this.startTime = new Date();

                document.removeEventListener('keypress', () => {
                    this.handleOutClick();
                });
            }

            // new Method
            const stopTime = () => {
                clearTimeout(this.timerId)
                this.setState({ remainTime: this.timerId });
            }
            // this.startTime = new Date();
            this.selectedCount = 0;
            this.timerId = setTimeout(() => {
                this.timerLog();
                if (slideCount === imageCount) {
                    this.slideIndex = 0;
                    this.handleImageLoad()
                }
                if ((slideCount - 1) === imageCount) {
                    this.nextCount++;
                    this.slideIndex = 0;
                    if (this.selectedItemArr.length < minSelections) {
                        this.setState({ popUpModal: true })

                        if (this.nextCount === 1 && configuration.continueButton === null) {
                            setTimeout(() => {
                                this.onContinueButton();
                            }, 0);
                            clearTimeout(this.timerId);
                        } else if (configuration.continueButton !== null && !isLastPage) {

                            this.setState({ isContinueButton: !this.state.isContinueButton });
                        }

                    }
                    else if (minSelections === "undefined" || "null" || 0 && this.state.isClick == false && (slideCount - 1) === imageCount) {
                        //   this.nextCount++; 
                        this.slideIndex = 0;
                        if (this.nextCount === 1 && configuration.continueButton === null) {
                            setTimeout(() => {
                                this.onContinueButton();
                            }, 0);
                            clearTimeout(this.timerId);
                        } else if (configuration.continueButton !== null && !isLastPage) {

                            this.setState({ isContinueButton: !this.state.isContinueButton });
                        }
                        // this.handleImageLoad()

                        this.setState({ popUpModal: false })
                    }
                    if (this.buttonHide !== null) {
                        clearTimeout(this.timerId);

                        if (parseInt(randomizePresentation) === 1) {
                            slides[randomIndex].style.display = "none";
                        } else {
                            slides[imageCount].style.display = "none";
                        }
                        this.buttonHide.style.display = "inline";

                        this.handleClose();
                    }

                } else {
                    this.endTime = new Date();
                    document.removeEventListener('keypress', () => {
                        this.handleOutClick();
                    });
                    if (totalTime && totalTime !== 0) {
                        clearTimeout(this.timerId);
                        this.setState({ isPlaying: false });
                        this.props.openOreModal ? stopTime() :
                            this.state.remainTime !== null ?
                                setTimeout(() => {
                                    this.setState({ remainTime: null });
                                    this.handleImageLoad();
                                }, this.state.remainTime)
                                : setTimeout(() => {
                                    slides[randomIndex].style.display = "none";
                                    slides[imageCount].style.display = "none";
                                    progressBar[0].classList.remove('_imageProgressBar');
                                    progressBar[0].style.display = "none";
                                    this.setState({ isPlaying: false });
                                    this.runningTime = performance.now();
                                    setTimeout(() => {
                                        this.slideIndex++;
                                        progressBar[0].classList.add('_imageProgressBar');
                                        progressBar[0].style.display = "block";
                                        this.setState({ isPlaying: true });
                                        this.handleImageLoad();
                                        this.endTime = null;
                                    }, totalTime);

                                }, 50);
                    } else {
                        document.removeEventListener('keypress', () => {
                            this.handleOutClick();
                        });
                        this.slideIndex++;
                        this.handleImageLoad();
                    }
                }

            }, maxTimeToSelect);

        } catch (error) {
            console.log("Exception: while loading image:_", error.message)
        }
    }

    handleContinueButton = () => {
        this.handleModelClose()
    }
    uniqueShuffle = (array) => {

        try {
            var excludedIndices = this.setOfTheImages.length;
            var currentIndex = array.length - 1;
            // Shuffle the array excluding the first three indices
            while (currentIndex > excludedIndices) {
                var randomIndex = Math.floor((Math.random() * (currentIndex - excludedIndices)) + excludedIndices);
                // Swap elements
                var temporaryValue = array[currentIndex];
                array[currentIndex] = array[randomIndex];
                array[randomIndex] = temporaryValue;

                currentIndex -= 1;

            }

            return array;
        } catch (error) {
            console.log("Exception: while shuffling array:_", error.message);
        }
    }

    handleStart = () => {
        const { items, pageInstrumentConfiguration, getAllItemResponse, itemResponses, configuration } = this.props;
        const { scales } = pageInstrumentConfiguration;
        const { itemResponseSets } = getAllItemResponse;
        const { readySetGoImageTime } = configuration;
        var slides = document.getElementsByClassName(`_imageItemTypeUrl_${configuration.key}`);
        var tempReadyToSetImageUrl = document.getElementsByClassName(`_readyToSetImageUrl_${configuration.key}`);
        var progressBar = document.getElementsByClassName(`_imageProgressBar_${configuration.key}`);
        clearTimeout(this.timerId);
        for (const key in this.reviewPage[items.reviewPageKey]) {
            if (this.reviewPage.hasOwnProperty(items.reviewPageKey)) {
                const itemList = this.reviewPage[items.reviewPageKey][key];
                const scaleResponses = scales[itemList.scaleKey];
                const scaleResponseTemp = scaleResponses.scaleResponses;
                var imageLength = items.socializationImages.length;
                // const allScaleResponse = scaleResponses.scaleResponses;
                const allScaleResponse = scaleResponseTemp.filter((item, index) => index >= imageLength);
                const responseSet = itemResponses[itemList.key] = {};
                const tempItemResponseArr = [];
                for (let index = 0; index < allScaleResponse.length; index++) {
                    tempItemResponseArr.push({
                        'buttonGroup': null,
                        'isNa': false,
                        'itemType': parseInt(itemList.itemType),
                        'openEnd': null,
                        'response': allScaleResponse[index].response,
                        'responseValue': null,
                        'sequence': index + 1,
                    });
                    itemList.itemResponses[itemList.key] = tempItemResponseArr;
                    itemList.userResponse = tempItemResponseArr;
                }
                if (itemResponseSets && itemResponseSets.length > 0) {
                    for (const key in itemResponseSets) {
                        if (itemResponseSets.hasOwnProperty(key)) {

                            const tempItemResponseSets = itemResponseSets[key];
                            var tempItemResponse = itemList.userResponse;
                            if (itemList.key === tempItemResponseSets.itemKey) {

                                for (const key in tempItemResponseSets.itemResponses) {
                                    if (tempItemResponseSets.itemResponses.hasOwnProperty(key)) {
                                        const element = tempItemResponseSets.itemResponses[key];
                                        var objIndex = tempItemResponse.findIndex((obj => obj.sequence === element.sequence));
                                        tempItemResponse[objIndex] = element;
                                        itemList.userResponse = tempItemResponse;
                                    }
                                }
                            }
                        }
                    }
                }
                this.itemCollection = itemList.userResponse;
                processItemResponse(itemList.key, responseSet, itemList.userResponse, itemList.itemType, "onChange");
            }
        }
        var scrollDiv = document.getElementsByClassName("_test");
        this.slideIndex = 0;

        if (readySetGoImageTime !== 0) {
            var sliderTime = setTimeout(() => {
                scrollDiv[0].style.paddingTop = "0px";;
                scrollDiv[0].scrollIntoView({ top: scrollDiv.offsetTop });
                window.scrollTo(0, 0)
                progressBar[0].classList.remove('_imageProgressBar');
                progressBar[0].style.display = "none";

                for (var i = 0; i < slides.length; i++) {
                    if (slides[i].style !== undefined) {
                        slides[i].style.display = "none";
                        tempReadyToSetImageUrl[0].style.display = 'block';
                    }

                    this.setState({ isPlaying: false });
                }

                clearTimeout(sliderTime);
            }, 0);
            var sliderLoad = setTimeout(() => {
                tempReadyToSetImageUrl[0].style.display = 'none';
                progressBar[0].style.display = "block";
                progressBar[0].classList.add('_imageProgressBar');
                this.setState({ isPlaying: true });

                this.handleImageLoad();
                clearTimeout(sliderLoad);
            }, readySetGoImageTime);
        } else {
            setTimeout(() => {
                scrollDiv[0].style.paddingTop = "0px";;
                scrollDiv[0].scrollIntoView({ top: scrollDiv.offsetTop });
                window.scrollTo(0, 0)
                tempReadyToSetImageUrl[0].style.display = 'none';
                this.handleImageLoad();
            }, 0);
        }

        this.setState({ isStartButton: !this.state.isStartButton, showModal: true });
    }

    handleImageItem = (newItem, index, rateeKey) => {

        try {
            const { items, dispatch, configuration, pageInstrumentConfiguration, ratees, putAllForItemCollection } = this.props;

            const { scales } = pageInstrumentConfiguration;
            const { minSelections, maxSelections, minimumSelectionTime, extraTimeToSelect, maxTimeToSelect, imageInterval } = configuration.itemTypeProperties;
            const endTime = new Date() - this.endTime;

            this.selectedCount++;
            this.selectedItemArr.push(this.selectedCount);

            const selectionItemCount = this.selectedItemArr.length;
            if (minSelections && maxSelections) {
                if (selectionItemCount >= minSelections && selectionItemCount <= maxSelections) {
                    const nodes = document.getElementById("_img_" + newItem.response + "_" + configuration.key);
                } else {
                    console.log("Limit cross")
                }
            } else {
                const nodes = document.getElementById("_img_" + newItem.response + "_" + configuration.key);
            }
            this.setState({ imgBorder: 10 });

            const selected = document.getElementsByClassName("_selectedImg" + newItem.response + "_" + configuration.key)[0];
            selected.classList.add("_selectedItem");
            var itemResponseTime = endTime - this.startTime;            
            var allTime = null;
            if (maxTimeToSelect && extraTimeToSelect > 0) {
                allTime = (parseInt(maxTimeToSelect) + parseInt(extraTimeToSelect));
            } else if (maxTimeToSelect) {
                allTime = parseInt(maxTimeToSelect);
            }
            var responseTime = null;
            if (extraTimeToSelect > 0) {
                const remainingTime = performance.now() - this.runningTime;
                responseTime = parseInt(maxTimeToSelect) + parseInt(remainingTime);
            } else if (maxTimeToSelect) {
                if (imageInterval & extraTimeToSelect) {
                    responseTime = maxTimeToSelect - (endTime - this.startTime);
                } else if (imageInterval) {
                    responseTime = this.clickedValues;
                } else {
                    responseTime = this.clickedValues;
                }
            }
            if (this.clickCount === 1) {
                this.responseValue = Math.sign(itemResponseTime) === -1 ? parseInt(responseTime) : itemResponseTime;
                if (this.responseValue > allTime) {
                    this.responseValue = allTime;
                } 
            } else if (this.handleLoadClick) {
                this.responseValue = Math.sign(itemResponseTime) === -1 ? parseInt(responseTime) : itemResponseTime;
                if (this.responseValue > allTime) {
                    this.responseValue = allTime;
                }
            }
            this.setState({ isApiCall: true });
            /* Manage the question answer response */
            for (const key in this.reviewPage[items.reviewPageKey]) {
                if (this.reviewPage.hasOwnProperty(items.reviewPageKey)) {
                    const itemList = this.reviewPage[items.reviewPageKey];
                    var itemKey = itemList[key].key;

                    if (itemList[key].key.toLowerCase() === items.key.toLowerCase()) {
                        for (const rKey in ratees) {

                            if (ratees.hasOwnProperty(rKey)) {
                                const tempRatees = ratees[rKey];

                                if (tempRatees.dataCollectionGuid === rateeKey) {
                                    itemList[key].isAnswer = true;
                                    itemList[key].isRequired = false;

                                    itemList[key].itemResponses[itemKey] = [{
                                        "itemType": configuration.itemType,
                                        "buttonGroup": null,
                                        "sequence": index,
                                        "isNa": itemList[key].isNA,
                                        "response": newItem.response,
                                        "responseValue": parseInt(this.responseValue),
                                        "openEnd": null,
                                    }];

                                    this.itemCollection.filter((items, i) => {
                                        if (items.response === itemList[key].itemResponses[itemKey][0].response) {
                                            items.responseValue = parseInt(this.responseValue)
                                        }
                                    });

                                    itemList[key].userResponse = this.itemCollection;
                                    var responseSet = this.props.itemResponses[itemKey] = {};
                                    var itemResponses = itemList[key].userResponse;
                                    var itemType = configuration.itemType;

                                    if (minSelections && maxSelections) {
                                        if (selectionItemCount >= minSelections && selectionItemCount <= maxSelections) {
                                            processItemResponse(itemKey, responseSet, itemResponses, itemType, rateeKey, putAllForItemCollection, "onChange");
                                        } else {
                                            console.log(`You can select only min = ${minSelections} and max = ${maxSelections}`)
                                        }
                                    } else {
                                        processItemResponse(itemKey, responseSet, itemResponses, itemType, rateeKey, putAllForItemCollection, "onChange");
                                    }
                                }
                            }
                        }
                    } else {
                        if (itemList[key].isAnswer !== true) itemList[key].isAnswer = false;
                    }
                    this.setState({ itemResponses: itemList[key].itemResponses[itemList[key].key] });
                }
            }
            dispatch(getQuestionList(this.reviewPage));
        } catch (error) {
            console.log("Exception: while responding question answer in ranked response:_", error);
        }
    }

    onContinueButton = () => {
        try {
            const { items, configuration, activePageKey, rateeKey } = this.props;
            const { isPracticeItem, oneTimeOnly } = configuration.itemTypeProperties;

            const nextButton = document.getElementsByClassName(`_buttonHideClass_${activePageKey}`)[0];
            var buttonsEl = document.getElementById(`commonBtn_${items.key}`);
            this.setState({ isApiCall: true });
            const { isApiCall } = this.state;

            clearTimeout(this.timerId);

            document.removeEventListener('keypress', () => {
                this.handleOutClick();
            }, false);

            setTimeout(() => {
                this.handleClose();
                this.reviewPage[items.key][0].isAnswer = true;
                this.reviewPage[items.key][0].isRequired = false;

                this.selectedItemArr = [];

                if (isApiCall && isPracticeItem !== "1") {

                    this.props.handleItemResponse(items.key, this.props.itemResponses, "itemChange", rateeKey);
                    this.setState({ isApiCall: false });

                    if (nextButton) {
                        nextButton.classList.remove('_PageNextButtonDisable');
                    }
                } else {
                    delete this.props.itemResponses[items.key];

                    if (nextButton) {
                        nextButton.disabled = false;
                        nextButton.classList.add('_PageNextButtonDisable');
                    } else {
                        nextButton.classList.remove('_PageNextButtonDisable');
                    }

                    if (buttonsEl !== null && oneTimeOnly === "1" && items.isAnswer === true) {
                        buttonsEl.style.display = "none";
                    }
                }
            }, 0);

            var itemBlock = document.getElementsByClassName(`_ImageItemType`);

            for (let index = 0; index < itemBlock.length; index++) {
                itemBlock[index].style.display = "block";
            }
            this.itemBlock--;
            itemBlock[this.itemBlock].style.display = "block";

            this.setState({ isContinueButton: !this.state.isContinueButton });
        } catch (error) {
            console.log("Exception: while rendering next same item type:_", error.message);
        }
    }

    handleOpen = () => {
        const { configuration } = this.props;
        const { startButton } = configuration;
        if (startButton !== null) {
            var tempReadyToSetImageUrl = document.getElementsByClassName(`_readyToSetImageUrl_${this.props.configuration.key}`);
            var sliderLoad = setTimeout(() => {
                tempReadyToSetImageUrl[0].style.display = 'none';
                clearTimeout(sliderLoad);
            }, 0);
        } else {
            this.handleStart();
        }
        this.isLoadSlider = true;
        this.setState({ showModal: true });
    }
    handleLastClick = () => {

        const { configuration } = this.props;
        const { extraTimeToSelect } = configuration.itemTypeProperties;
        const { isHiding, lastSelected } = this.state;
        if (isHiding && this.handleLoadClick && !lastSelected && extraTimeToSelect > 0) {
            this.setState({ isVisible: true })
        } else if (isHiding && lastSelected && extraTimeToSelect > 0) {
            this.setState({ isVisible: false })
        }
    }

    handleClose = () => {
        this.setState({ checkValue: true, isHiding: true })
        const { configuration } = this.props;
        const { extraTimeToSelect } = configuration.itemTypeProperties;

        setTimeout(() => {
            this.isLoadSlider = false;
            this.setState({ showModal: false, isStartButton: false });
        }, extraTimeToSelect);
    }

    handleModelClose = () => {
        this.isLoadSlider = false;
        this.handleOpen();
        this.selectedItemArr = [];
        this.isImages = [];
        this.setState({ popUpModal: false });
    }
    handleImageClick = (img) => {
        const { configuration } = this.props;
        const { minSelections } = configuration.itemTypeProperties;

        this.isImages.push(img);
        const selectedImages = this.isImages.length
        if (selectedImages >= minSelections) {
            this.setState({ isClick: true })

        } else {
            this.setState({ isClick: false })
        }
    }

    handleModelContinue = () => {
        this.isLoadSlider = false;
        this.setState({ popUpModal: false });
    }

    remainingTime = ({ remainingTime }) => {
        return (
            <div className="timer">
                <div className="text-center">{remainingTime}</div>
            </div>
        );
    };

    timerLog = () => {
        return [true, 0];
    }

    onImgLoad = (i) => {
        try {
            const { scaleResponses } = this.props.configuration;
            var loadImage = document.getElementsByClassName(`tempImage_${this.props.configuration.key}`);
            this.setState({ isImageLoaded: scaleResponses.length !== loadImage.length ? true : false });
        } catch (error) {
            console.log("Exceptions: image preloading:_", error.message)
        }
    }


    handleOutClick = () => {
        try {
            this.clickCount++;
            var slides = document.getElementsByClassName(`_imageItemTypeUrl_${this.props.configuration.key}`);
            var slideCount = slides.length || 0;
            var imageCount = this.slideIndex;
            if (this.clickCount === 1) {
                const endTime = new Date() - this.endTime;
                this.clickedValues = endTime;
                if (slides.length > 0) {
                    if ((slideCount - 1) === imageCount) {
                        this.setState({ lastSelected: true, isVisible: false })
                    }
                    this.setState({ isImageSelected: true })
                    slides[this.itemChangeCount].disabled = true;
                    var index = slides[this.itemChangeCount].getAttribute('data-index');
                    var newItem = slides[this.itemChangeCount].getAttribute('data-id');
                    var itemsData = JSON.parse(newItem);
                    this.handleImageItem(itemsData, index + 1, this.props.rateeKey);
                }
            }
            document.removeEventListener('keypress', () => {
                this.handleOutClick();
            });
        } catch (error) {
            console.log("Exceptions:capturing event", error.message)
        }
        this.setState({ isAvailable: true })
    }

    handleLoadingClick = () => {

        const { selectedImageIndex } = this.state;
        try {
            this.clickCount++;
            var slides = document.getElementsByClassName(`_imageItemTypeUrl_${this.props.configuration.key}`);
            var slideCount = slides.length || 0;
            var imageCount = this.slideIndex;
            if (this.clickCount === 1) {
                if (slides.length > 0) {
                    if ((slideCount - 1) === imageCount) {
                        debugger;
                        this.setState({ isVisible: true })
                    }
                    slides[this.itemChangeCount].disabled = true;
                    var index = slides[this.itemChangeCount].getAttribute('data-index');
                    var newItem = slides[this.itemChangeCount].getAttribute('data-id');
                    var itemsData = JSON.parse(newItem);
                    this.handleImageItem(itemsData, index - 1, this.props.rateeKey);
                    this.setState({ selectedImageIndex: index - 1, selectedImageName: newItem.response })

                    // slides[selectedImageIndex].style.display = "block";
                    // }
                }
            }
            document.removeEventListener('keypress', () => {
                this.handleLoadingClick();
            });

        } catch (error) {
            console.log("Exceptions:capturing event", error.message)
        }
    }
    handleSelectionTime = () => {

        const remainingTime = performance.now() - this.runningTime;
        if (!this.state.isImageSelected) {

            if (remainingTime < this.selectionTime) {

                this.handleLoadingClick()
                this.handleLoadClick = true;
                this.setState({ isVisible: true })
                setTimeout(() => {
                    this.setState({ isVisible: false })
                }, 300);
            } else if (this.selectionTime === remainingTime) {
                this.handleLoadingClick()
            }
        }
    }
    render() {
        const { configuration, pageInstrumentConfiguration, isLastPage, items, rateeKey } = this.props;
        const { key, className, scaleResponses, startButton, continueButton, readyToStartButton, responseThresholdContinueButtonKey, responseThresholdMessage } = configuration;
        const { buttons, sections, scales } = pageInstrumentConfiguration;
        const { isStartButton, isContinueButton, showModal, isPlaying, isImageLoaded, checkOre, popUpModal } = this.state;
        const imgContinueBtn = scales[key].responseThresholdContinueButtonKey;

        const imgRevisitBtn = scales[key].responseThresholdTryAgainButtonKey;


        const { minimumSelectionTime, oneTimeOnly, isPracticeItem, minSelections, maxTimeToSelect, extraTimeToSelect } = configuration.itemTypeProperties;
        var miniMumTimeSelection = minimumSelectionTime && minimumSelectionTime !== undefined ? minimumSelectionTime : 0;

        var buttonsEl = document.getElementById(`commonBtn_${items.key}`);

        if (buttonsEl !== null && (oneTimeOnly === "1" || isPracticeItem === '1') && items.isAnswer === true) {
            buttonsEl.style.display = "none";
        }
        const isIPad = /iPad/.test(navigator.userAgent);
        var OSName = "Unknown OS"
        if (navigator.userAgent.indexOf("Android") != -1) OSName = "Android";
        if (navigator.userAgent.indexOf("like Mac") != -1) OSName = "iOS";
        // if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
        //     // This is Safari
        //     document.body.classList.add('safari');
        // }
        // if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent) && window.matchMedia("(orientation: landscape)").matches) {
        //     document.body.classList.add('safari');
        // }
        // This is Safari on an iPad in landscape mode
        var browserName;

        var userAgent = navigator.userAgent.toLowerCase();

        if (userAgent.indexOf('safari') !== -1 && userAgent.indexOf('chrome') === -1) {
            browserName = 'Safari';
        } else if (userAgent.indexOf('firefox') !== -1) {
            browserName = 'Mozilla Firefox';
        } else if (userAgent.indexOf('edge') !== -1) {
            browserName = 'Microsoft Edge';
        } else if (userAgent.indexOf('trident') !== -1 || userAgent.indexOf('msie') !== -1) {
            browserName = 'Internet Explorer';
        } else {
            browserName = 'Unknown'; // If none of the known browsers are detected
        }


        return (
            <Fragment>
                <Row>
                    <Col md="12">
                        {configuration.scalePreSection !== null ? <div dangerouslySetInnerHTML={{ __html: processResponse(configuration.scalePreSection) }}></div> : null}
                        <div>
                            {scaleResponses.map((item, indx) => {
                                return <>
                                    <img
                                        style={{ display: "none" }}
                                        src={item.responseImageUrl}
                                        className={`tempImage_${configuration.key}`}
                                        // onClick={()=>this.setState({isClick:true,}) }
                                        onLoad={() => this.onImgLoad(indx + 1)}
                                        onError={() => this.onImgLoad({ item })}
                                    />
                                </>
                            })}
                            <Modal
                                show={showModal}
                                aria-labelledby="contained-modal-title-center"
                                onHide={this.handleClose}
                                showCloseIcon={false}
                                animation={true}
                                size="xl"
                                id="_modal"
                            >
                                <Modal.Body
                                    //id="_modal"

                                    className="font-weight-bold text-left _test "
                                    onClick={this.state.isPlaying ? this.handleOutClick : this.handleSelectionTime}
                                    onTouchStart={this.state.isPlaying ? this.handleOutClick : this.handleSelectionTime}
                                    onKeyDown={this.state.isPlaying ? this.handleOutClick : this.handleSelectionTime}
                                    style={{ display: isMobile || isTablet ? 'flex' : 'block', justifyContent: 'center', alignItems: 'center' }}
                                >
                                    {(isMobile || isTablet) && (checkOre == 'landscape' || pageInstrumentConfiguration.orientation == 'landscape') ?
                                        <Row className="imageItemResponseRow">
                                             <div id="extraTimeSelection" class="_extraTimeCheckmk" style={{ display: this.state.isVisible ? 'block' : 'none' }}>
                                                <i className={this.state.isVisible ? 'fa fa-check fa-2x checkmkShow' : 'hidden'} style={{ display: 'block' }}></i>
                                                <p style={{color: 'black' }}>{pageInstrumentConfiguration.lateImageSelectionMessage}</p>
                                            </div>
                                            <Col md="1"></Col>
                                            <Col className={'_imageModalSection'} md="10" style={{ alignContent: "center", position: "relative" }}>
                                                {
                                                    items.itemPreSectionKey !== null && sections.hasOwnProperty(items.itemPreSectionKey) ?
                                                        <ItemSection key={sections[items.itemPreSectionKey].key} className={sections[items.itemPreSectionKey].className} />
                                                        : null
                                                }
                                                <Row>
                                                    <Col xs={4} className="_imageItemText _ImageTextAlign">
                                                        <span style={{ userSelect: "none" }} dangerouslySetInnerHTML={{ __html: processResponse(items.itemText) }}>{ }</span>
                                                    </Col>
                                                    <Col xs={8}>
                                                        < div className={`_imageProgressBar _imageProgressBar_${configuration.key}`}>
                                                            {!this.state.checkValue ? <CountdownCircleTimer
                                                                isPlaying={isPlaying}
                                                                duration={parseInt(maxTimeToSelect) / 1000}
                                                                colors="#4caf50"
                                                                size={40}
                                                                strokeWidth={5}
                                                                onComplete={this.timerLog}
                                                            >
                                                                {this.remainingTime}
                                                            </CountdownCircleTimer> : ""}
                                                        </div>
                                                        {scaleResponses.map((item, indx) => {
                                                            return <>
                                                                {item.responseImageUrl ?
                                                                    <div
                                                                        key={item.responseImageUrl}
                                                                        id={`_imageItemTypeUrl_${configuration.key}`}
                                                                        className={`_imageItemTypeUrl_${configuration.key} _imageRenderClass divideSection`}
                                                                        data-id={JSON.stringify(item)}
                                                                        data-index={indx + 1}
                                                                    >
                                                                        <div style={{
                                                                            backgroundImage: `url(${item.responseImageUrl})`,
                                                                            border: `${this.state.imgBorder}px solid #008000`
                                                                        }}
                                                                            key={item.responseDescription}
                                                                            id={"_img_" + item.response + '_' + key}
                                                                            onKeyPress={() => this.handleImageItem(item, indx + 1, rateeKey)}
                                                                            onKeyDown={this.test}
                                                                            onClick={() => this.handleImageClick(item.response)}
                                                                            alt={item.responseTooltip}
                                                                            className={isMobile && OSName === "iOS" ? (isIPad ? "_iPadImageItemResponseDiv" : "_iOSimageItemResponseDiv") : "_imageItemResponseDiv"}

                                                                            name={`_imageItemResponse`}
                                                                            data-el={item}
                                                                        ></div>
                                                                    </div>
                                                                    : item.responseDescription}
                                                                <div className="_itemTempClass">
                                                                    <div id="_selectedItem" className={"_selectedImg" + item.response + '_' + key} >Response:<b>{item.response}</b> ResponseValue:<b>{this.responseValue}</b>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        })}
                                                        <div style={{ display: ((isMobile || isTablet) && ((checkOre == 'landscape' || pageInstrumentConfiguration.orientation == 'landscape'))) ? (!this.started) ? 'block' : 'none' : 'none' }} className="_alignDivideSectionLoader">
                                                            <div className={`_readyToSetImageUrl_${configuration.key} _imageRenderClass`} style={{ textAlign: "center" }}>
                                                                {configuration.readySetGoImageUrl && configuration.readySetGoImageUrl !== null ?
                                                                    <img
                                                                        src={configuration.readySetGoImageUrl}
                                                                        alt="readyToGoImage"
                                                                        className="_readyToSetImageUrl"
                                                                    />
                                                                    : null
                                                                }
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>

                                                {items.itemPostSectionKey !== null && sections.hasOwnProperty(items.itemPostSectionKey) && !isStartButton ?
                                                    <ItemSection
                                                        key={sections[items.itemPostSectionKey].key}
                                                        type="itemPostSection"
                                                        html={sections[items.itemPostSectionKey].content}
                                                        className={sections[items.itemPostSectionKey].className}
                                                    /> : null}

                                                {startButton && buttons.hasOwnProperty(startButton) && !isStartButton ?
                                                    <Button
                                                        key={buttons[startButton].key}
                                                        onClick={() => this.handleStart()}
                                                        className={`_ImageItemStartButton ${buttons[startButton].buttonCssClass}`}
                                                    >
                                                        {buttons[startButton].buttonText}
                                                    </Button> : null
                                                }
                                            </Col>
                                            <Col md="1"></Col>
                                        </Row>
                                        :
                                        <Row className="imageItemResponseRow">
                                             <div id="extraTimeSelection" class="_extraTimeCheckmk" style={{ display: this.state.isVisible ? 'block' : 'none' }}>
                                                <i className={this.state.isVisible ? 'fa fa-check fa-2x checkmkShow' : 'hidden'} style={{ display: 'block' }}></i>
                                                <p style={{color: 'black' }}>{pageInstrumentConfiguration.lateImageSelectionMessage}</p>
                                            </div>
                                            <Col md="1"></Col>
                                            <Col className={'_imageModalSection'} md="10">
                                                {
                                                    items.itemPreSectionKey !== null && sections.hasOwnProperty(items.itemPreSectionKey) ?
                                                        <ItemSection key={sections[items.itemPreSectionKey].key} className={sections[items.itemPreSectionKey].className} />
                                                        : null
                                                }
                                                <div className="_imageItemText" style={{ userSelect: "none" }} dangerouslySetInnerHTML={{ __html: processResponse(items.itemText) }}>{ }</div>
                                                <div className={`_imageProgressBar _imageProgressBar_${configuration.key}`}>
                                                    {!this.state.checkValue ? <CountdownCircleTimer
                                                        isPlaying={isPlaying}
                                                        duration={parseInt(maxTimeToSelect) / 1000}
                                                        colors="#4caf50"
                                                        size={40}
                                                        strokeWidth={5}
                                                        onComplete={this.timerLog}
                                                    >
                                                        {this.remainingTime}
                                                    </CountdownCircleTimer> : ""}
                                                </div>
                                                {scaleResponses.map((item, indx) => {
                                                    return <>
                                                        {item.responseImageUrl ?
                                                            deviceType == "browser" ?
                                                                <div className="aspect-ratio-box">
                                                                    <img style={deviceType == "browser" ? {
                                                                        border: `${this.state.imgBorder}px solid #008000`,
                                                                    } : { border: `${this.state.imgBorder}px solid #008000` }}
                                                                        src={item.responseImageUrl}
                                                                        key={item.responseDescription}
                                                                        id={"_img_" + item.response + '_' + key}
                                                                        onKeyPress={() => this.handleImageItem(item, indx + 1, rateeKey)}
                                                                        onKeyDown={this.test}
                                                                        alt={item.responseTooltip}
                                                                        onClick={() => this.handleImageClick(item.response)}
                                                                        className={`_imageItemTypeUrl_${configuration.key}`}
                                                                        name={`_imageItemResponse`}
                                                                        data-el={item}
                                                                        data-id={JSON.stringify(item)}
                                                                        data-index={indx + 1}
                                                                    ></img>
                                                                </div> :
                                                                <div
                                                                    key={item.responseImageUrl}
                                                                    id={`_imageItemTypeUrl_${configuration.key}`}
                                                                    className={`_imageItemTypeUrl_${configuration.key} _imageRenderClass newTest`}
                                                                    data-id={JSON.stringify(item)}
                                                                    data-index={indx + 1}
                                                                >
                                                                    <div style={{
                                                                        backgroundImage: `url(${item.responseImageUrl})`,
                                                                        border: `${this.state.imgBorder}px solid #008000`
                                                                    }}
                                                                        key={item.responseDescription}
                                                                        id={"_img_" + item.response + '_' + key}
                                                                        onKeyPress={() => this.handleImageItem(item, indx + 1, rateeKey)}
                                                                        onKeyDown={this.test}
                                                                        alt={item.responseTooltip}
                                                                        onClick={() => this.handleImageClick(item.response)}
                                                                        className={`_imageItemResponseDiv`}
                                                                        name={`_imageItemResponse`}
                                                                        data-el={item}
                                                                    ></div>
                                                                </div>
                                                            : item.responseDescription}
                                                        <div className="_itemTempClass">
                                                            <div id="_selectedItem" className={"_selectedImg" + item.response + '_' + key} >Response:<b>{item.response}</b> ResponseValue:<b>{this.responseValue}</b>
                                                            </div>
                                                        </div>
                                                    </>
                                                })}
                                                {items.itemPostSectionKey !== null && sections.hasOwnProperty(items.itemPostSectionKey) && !isStartButton ?
                                                    <ItemSection
                                                        key={sections[items.itemPostSectionKey].key}
                                                        type="itemPostSection"
                                                        html={sections[items.itemPostSectionKey].content}
                                                        className={sections[items.itemPostSectionKey].className}
                                                    /> : null
                                                }

                                                {startButton && buttons.hasOwnProperty(startButton) && !isStartButton ?
                                                    <Button
                                                        key={buttons[startButton].key}
                                                        onClick={() => this.handleStart()}
                                                        className={`_ImageItemStartButton ${buttons[startButton].buttonCssClass}`}
                                                    >
                                                        {buttons[startButton].buttonText}
                                                    </Button> : null
                                                }
                                            </Col>
                                            <Col md="1"></Col>
                                        </Row>
                                    }
                                    <div style={{ display: ((isMobile || isTablet) && (checkOre == 'landscape' || pageInstrumentConfiguration.orientation == 'landscape')) ? 'none' : (!this.started) ? 'block' : 'none' }}>
                                        <div className={`_readyToSetImageUrl_${configuration.key} _imageRenderClass`} style={{ textAlign: "center" }}>
                                            {configuration.readySetGoImageUrl && configuration.readySetGoImageUrl !== null ?
                                                <img
                                                    src={configuration.readySetGoImageUrl}
                                                    alt="readyToGoImage"
                                                    className="_readyToSetImageUrl"
                                                />
                                                : null
                                            }
                                        </div>
                                    </div>
                                </Modal.Body>
                            </Modal>
                            <Modal
                                show={popUpModal}
                                onHide={() => this.handleModelClose()}
                                animation={true}
                                centered={true}
                                size="md"
                                id="popUpModel"

                            >
                                <Modal.Body >
                                    <span className="_thresholdMsg">{this.selectedItemArr.length < minSelections ? responseThresholdMessage !== null ? responseThresholdMessage : "You did not select any images for the practice exercise. Would you like the opportunity to try again?" : ""}</span> <br />
                                    <Row className="_buttonsRow">
                                            <button onClick={() => this.handleModelClose()} className="_continue _popUpButtons">{imgRevisitBtn !== null && buttons[imgRevisitBtn].buttonText !== null ? buttons[imgRevisitBtn].buttonText : "Revisit"}</button>
                                            <button onClick={() => this.handleModelContinue()} className="_revisit _popUpButtons">{imgContinueBtn !== null && buttons[imgContinueBtn].buttonText !== null ? buttons[imgContinueBtn].buttonText : "Continue"}</button>
                                    </Row>
                                </Modal.Body>
                            </Modal>
                            <Row>
                                <Col xs={1}></Col>
                                <Col xs={10}>
                                    {items.itemInstructionPreSectionKey !== null && sections.hasOwnProperty(items.itemInstructionPreSectionKey) && items.isAnswer !== true && sections[items.itemInstructionPreSectionKey].content !== "" ?
                                        <ItemSection
                                            key={sections[items.itemInstructionPreSectionKey].key}
                                            type="itemInstructionPreSection"
                                            html={sections[items.itemInstructionPreSectionKey].content}
                                            className={sections[items.itemInstructionPreSectionKey].className}
                                        /> : items.itemInstructionPreSectionKey !== null && sections.hasOwnProperty(items.itemInstructionPreSectionKey) && sections[items.itemCompletionPreSectionKey].content !== "" ?
                                            <ItemSection
                                                key={sections[items.itemCompletionPreSectionKey].key}
                                                type="itemCompletionPreSection"
                                                html={sections[items.itemCompletionPreSectionKey].content}
                                                className={`${sections[items.itemCompletionPreSectionKey].className}`}
                                            /> : null}
                                </Col>
                                <Col xs={1}></Col>
                            </Row>
                            <Row>
                                <Col xs={1}></Col>
                                <Col xs={10} className={"_StartButtonRow"} >
                                    {readyToStartButton && buttons.hasOwnProperty(readyToStartButton) && oneTimeOnly === undefined ?
                                        <Button
                                            className={`_ImageItemReadyToStartButton ${buttons[readyToStartButton].buttonCssClass}`}
                                            onClick={this.handleOpen}
                                            disabled={isImageLoaded}
                                            id={`commonBtn_${items.key}`}
                                            size="lg">
                                            {buttons[readyToStartButton].buttonText}
                                        </Button> :
                                        oneTimeOnly === "1" && items.isAnswer === false ?
                                            <Button
                                                className={`_ImageItemReadyToStartButton ${buttons[readyToStartButton].buttonCssClass}`}
                                                onClick={this.handleOpen}
                                                disabled={isImageLoaded}
                                                id={`commonBtn_${items.key}`}
                                                size="lg">
                                                {buttons[readyToStartButton].buttonText}
                                            </Button> : null}
                                </Col>
                                <Col xs={1}></Col>
                            </Row>
                            <Row>
                                <Col xs={1}></Col>
                                <Col xs={10}>
                                    {items.itemInstructionPostSectionKey !== null && sections.hasOwnProperty(items.itemInstructionPostSectionKey) && items.isAnswer !== true && sections[items.itemInstructionPostSectionKey].content !== "" ?
                                        <ItemSection
                                            key={sections[items.itemInstructionPostSectionKey].key}
                                            type="itemInstructionPostSection"
                                            html={sections[items.itemInstructionPostSectionKey].content}
                                            className={sections[items.itemInstructionPostSectionKey].className}
                                        />
                                        : items.itemCompletionPostSectionKey !== null && sections.hasOwnProperty(items.itemCompletionPostSectionKey)
                                            && sections[items.itemCompletionPostSectionKey].content !== "" ?
                                            <ItemSection
                                                key={sections[items.itemCompletionPostSectionKey].key}
                                                type="itemCompletionPostSection"
                                                html={sections[items.itemCompletionPostSectionKey].content}
                                                className={sections[items.itemCompletionPostSectionKey].className}
                                            /> : null}
                                </Col>
                                <Col xs={1}></Col>
                            </Row>

                        </div>
                        {configuration.scalePostSection !== null ? <div dangerouslySetInnerHTML={{ __html: processResponse(configuration.scalePostSection) }}></div> : null}
                    </Col>
                </Row>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    answeredQuestionCount: state.survey.answeredQuestionCount,
    getAllItemResponse: state.survey.getAllItemResponse,
    getAllItemResponseForMultiple: state.survey.getAllItemResponseForMultiple
})

export default connect(mapStateToProps)(ImageItemResponse);

